import React, { useEffect, useState } from "react";
import { fetchPageData } from "../endpoint/pageApi";
import MainLayout from "../layouts/MainLayout";
import Solo_PractitionersTop from "../components/Solo_PractitionersTop/Solo_PractitionersTop";
import ShadowCardContainer from "../components/ShadowCardContainer/ShadowCardContainer";
import HowItWorks from "../components/HowItWorks/HowItWorks";
import { useMediaQuery } from "react-responsive";
import {
  _1200px,
  _1400px,
  _1500px,
  _1600px,
  _1700px,
  _1800px,
  _576px,
  _768px,
  _992px,
} from ".././utils/mediaBreakpoints";
import { baseUrl } from "../utils/base_url";
import { SoloPractitionersSecond } from "../components/Solo_PractitionersSecond/Solo_practitionersSecond";
import { useNavigate } from "react-router-dom";

const MainProductOverviewPage = ({ data, isMobile }) => {
  const _576 = useMediaQuery({ maxWidth: _576px });
  const _768 = useMediaQuery({ maxWidth: _768px });
  const _992 = useMediaQuery({ maxWidth: _992px });
  const _1200 = useMediaQuery({ maxWidth: _1200px });
  const _1400 = useMediaQuery({ maxWidth: _1400px });
  const _1500 = useMediaQuery({ maxWidth: _1500px });
  const _1600 = useMediaQuery({ maxWidth: _1600px });
  const _1700 = useMediaQuery({ maxWidth: _1700px });
  const _1800 = useMediaQuery({ maxWidth: _1800px });
  return (
    <>
      <div
        className="container-fluid m-0 p-0"
        style={{ backgroundColor: "#090D24" }}
      >
        <Solo_PractitionersTop
          heading={data?.new_hero?.heading}
          subHeading={data?.new_hero?.sub_heading}
          btntext={data?.new_hero?.CTA?.text}
          btnbg={data?.new_hero?.CTA?.backgroundColor}
          btnclr={data?.new_hero?.CTA?.textColor}
          btnurl={data?.new_hero?.CTA?.url}
          imgsrc1={`${baseUrl}${data?.new_hero?.images[0]?.url}`}
          imgsrcs={data?.new_hero?.images}
          imgsrc2={`${baseUrl}${data?.new_hero?.images[1]?.url}`}
          imgsrc3={`${baseUrl}${data?.new_hero?.images[2]?.url}`}
          isMobile={isMobile}
          toppadding={"3rem"}
          texttopmargin={"4.5rem"}
          headingfs={"fs70"}
          headinglh={"4.2rem"}
          issBottom={true}
        />

        {data?.how_it_work && (
          <HowItWorks data={data?.how_it_work} bgcolor={" #090D24"} />
        )}

        {data?.column_view?.column_childs?.map((item, index) => (
          <div className="col-12 ">
            <SoloPractitionersSecond
              staticBg={" #283950"}
              bg={item?.backgroundColor}
              mainclassleft={`col-lg-6 col-12  ${isMobile ? "" : ""}`}
              mainclassright={`d-none d-lg-block col-lg-6 col-12`}
              heading={item?.heading}
              imgsrc={item?.image}
              subheading={item?.bullets}
              // left={index % 2 === 0}
              left={_992 ? true : index % 2 === 0}
              isMobile={isMobile}
              mapping={item?.mapping}
            />
          </div>
        ))}

        {data?.outcomes && (
          <div className="py-5" style={{ backgroundColor: " #090D23" }}>
            <p
              className="text-white text-center fw500 mt-0 pb-2 lh-sm"
              style={{
                // lineHeight: "2.5rem",
                fontSize: _576
                  ? "20px"
                  : _768
                  ? "25px"
                  : _992
                  ? "25px"
                  : _1200
                  ? "28px"
                  : _1400
                  ? "28px"
                  : _1500
                  ? "30px"
                  : _1600
                  ? "38px"
                  : _1700
                  ? "38px"
                  : _1800
                  ? "40px"
                  : "40px",
              }}
              dangerouslySetInnerHTML={{
                __html: data?.outcomes?.text?.replace(/\n/g, "<br/>"),
              }}
            ></p>
          </div>
        )}
        {data?.info_cards && (
          <ShadowCardContainer cards={data?.info_cards?.details} />
        )}
      </div>
    </>
  );
};

const ProductOverview = ({ isMobile }) => {
  const [pageData, setPageData] = useState({});
  const [loader, setLoader] = useState(false);
  useEffect(() => {
    fetchPageData(
      `pages?filters[slug][$eq]=product-overview`,
      setPageData,
      setLoader,
      false
    );
  }, []);
  console.log("home DAta", pageData);
  return (
    <MainLayout loader={loader}>
      <div className="container-fluid p-0 overflow-x-hidden">
        <MainProductOverviewPage data={pageData} isMobile={isMobile} />
      </div>
    </MainLayout>
  );
};

export default ProductOverview;

// import { useMediaQuery } from "react-responsive";
// import {
//   _1200px,
//   _1400px,
//   _1500px,
//   _1600px,
//   _1700px,
//   _1800px,
//   _576px,
//   _768px,
//   _992px,
// } from ".././utils/mediaBreakpoints";
// import { fetchPageData } from "../endpoint/pageApi";
// import { useEffect, useState } from "react";
// const MainPageLayout = ({ pageEndpoint, allData, isMobile }) => {
//   const _576 = useMediaQuery({ maxWidth: _576px });
//   const _768 = useMediaQuery({ maxWidth: _768px });
//   const _992 = useMediaQuery({ maxWidth: _992px });
//   const _1200 = useMediaQuery({ maxWidth: _1200px });
//   const _1400 = useMediaQuery({ maxWidth: _1400px });
//   const _1500 = useMediaQuery({ maxWidth: _1500px });
//   const _1600 = useMediaQuery({ maxWidth: _1600px });
//   const _1700 = useMediaQuery({ maxWidth: _1700px });
//   const _1800 = useMediaQuery({ maxWidth: _1800px });
//   const [pageData, setPageData] = useState({});
//   const [loader, setLoader] = useState(false);

//   useEffect(() => {
//     fetchPageData(pageEndpoint, setPageData, setLoader, allData);
//   }, [pageEndpoint, allData]);
//   console.log("home DAta", pageData);

//   return (
//     <>
//     </>
//   );
// };
// export default MainPageLayout;

// const productcol = [
//   {
//     heading: "Power of Voice",
//     mapping: true,
//     sub_heading: [
//       `Scheduling meetings, setting reminders, or retrieving case information`,
//       `Take notes during client consultations, team discussions and lectures`,
//       `Retrieve case information and set agendas`,
//     ],
//     backgroundColor: "#1F46BE",
//   },
//   {
//     heading: "Power of Productivity",
//     mapping: true,
//     sub_heading: [
//       `Automatic organization and categorization of documents and emails, ensuring easy access and retrieval.`,
//       `Team specific customizable workflows, monitoring of progress on assigned tasks`,
//       `Quickly analyze lengthy legal documents and case files using AI-powered summaries.`,
//     ],
//     backgroundColor: "#090d24",
//   },
//   {
//     heading: "Power of Smart Work",
//     mapping: true,
//     sub_heading: [
//       `Automatic organization and categorization of documents and emails, ensuring easy access and retrieval.`,
//       `Team specific customizable workflows, monitoring of progress on assigned tasks`,
//       `Quickly analyze lengthy legal documents and case files using AI-powered summaries.`,
//     ],
//     backgroundColor: "#1F46BE",
//   },
// ];
